import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
import BodyAside from './BodyAside';

const twoColumnsCentered: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  px: 4,

  '.containerBox': {
    display: 'flex',

    '& > .leftSpacer': {
      display: responsive({ 0: 'none', 5: 'block' }),
      width: 'min(100vw, calc(100vw - 992px - 350px))',
      maxWidth: 'calc(( 100vw - 992px - 24px) / 2)',
    },

    '& > .centerBox': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(4),
      maxWidth: 'root',
      px: responsive({ 0: 0, 4: 4 }),
      width: '100%',
    },

    '& > .rightSpacer': {
      display: responsive({ 0: 'none', 4: 'flex' }),
      flex: '1 0 100%',
      flexDirection: 'column',
      maxWidth: 'max(350px, calc(( 100vw - 992px - 24px) / 2))',
    },

    '.mainSpacer': {
      width: '350px',
    },
  },

  '#TopBox': {
    header: {
      alignItems: 'center',
      display: 'flex',
      gap: 4,
      flexWrap: 'wrap',

      img: {
        width: 'mainImage',
        height: 'mainImage',
        flexShrink: 0,
        display: responsive({ 0: 'none', 2: 'block' }),
      },

      section: {
        display: 'flex',
        flexDirection: 'column',

        hgroup: {
          alignItems: responsive({ 0: 'start', 3: 'end' }),
          display: 'flex',
          gap: responsive({ 0: 0, 3: 4 }),
          flexDirection: responsive({ 0: 'column', 3: 'row' }),
        },
      },

      '.underHeaderAside': {
        flexBasis: '100%',
      },
    },

    nav: {
      alignItem: 'center',
      display: 'flex',
      justifyContent: 'end',
      width: responsive({ 0: 'auto', 5: '350px' }),
      gap: 1,
    },

    '.rightSpacer': {
      justifyContent: 'center',
      flex: responsive({ 0: 'none', 5: 'thisValueWasUnsetValue' }),
    },

    '.HamburguerIconWrapper': {
      alignItems: 'center',
      display: responsive({ 0: 'none', 3: 'flex', 4: 'none' }),
      gap: 1,
      justifyContent: 'end',
      paddingRight: '32px',
      width: 'auto',
    },

    '.TitleContainer': {
      maxWidth: responsive({ 0: '100vw', 5: 'root' }),
    },
  },

  '#MiddleBox': {
    aside: {
      width: '350px',
    },
  },

  '#ResponsiveButtons': {
    justifyContent: 'end',
    gap: 1,
    display: responsive({ 0: 'flex', 3: 'none' }),
  },

  '#BodyAside': BodyAside,
};

export default twoColumnsCentered;
